import {Static, Type} from '@sinclair/typebox';
import {TFirebaseMediaLibraryItemReady} from './FirestoreClientInterfaces';
import {TCompQuestion, TDynamicResolutionRule} from './FirestoreInterfaces';

export const TPrediction = Type.Object({
  model: Type.String(),
  maxOutputTokens: Type.Number(),
  temperature: Type.Number(),
  topP: Type.Number(),
  executionTime: Type.Number(),
  prompt: Type.String(),
  promptTokens: Type.Number(),
  prediction: Type.String(),
  predictionTokens: Type.Number(),
  systemInstruction: Type.Optional(Type.String()),
  reasoning: Type.String(),
});
export type TPrediction = Static<typeof TPrediction>;

export const TQuestionPrediction = Type.Object({
  question: TCompQuestion,
  prediction: TPrediction,
});
export type TQuestionPrediction = Static<typeof TQuestionPrediction>;

export const TCaptionPrediction = Type.Object({
  caption: Type.String(),
  name: Type.String(),
  prediction: TPrediction,
});
export type TCaptionPrediction = Static<typeof TCaptionPrediction>;

export type TalkingPointCategory = 'win' | 'score' | 'ins_outs' | 'hot' | 'not_hot' | 'article_driven';

export const TStructuredTalkingPoint = Type.Object({
  rank:                   Type.Number(),
  title:                  Type.String(),
  summary:                Type.String(),
  supportingArticleIds:   Type.Array(Type.String()),
  bestArticleId:          Type.String(),
  suggestedQuestionTypes: Type.Array(Type.String()),
  category:               Type.Optional(Type.String()),
  insufficient_data:      Type.Optional(Type.Boolean()),
});
export type TStructuredTalkingPoint = Static<typeof TStructuredTalkingPoint>;

export const TTalkingPointArticleSummary = Type.Object({
  url: Type.String(),
  domain: Type.String(),
  title: Type.Optional(Type.String()),
  imageThumb: Type.Optional(Type.String()),
  imageContained: Type.Optional(Type.String()),
  icon: Type.Optional(Type.String()),
  siteName: Type.Optional(Type.String()),
  publishedAt: Type.Optional(Type.String()),
});
export type TTalkingPointArticleSummary = Static<typeof TTalkingPointArticleSummary>;

export const TTalkingPointsDocument = Type.Object({
  text: Type.String(),
  structured: Type.Array(TStructuredTalkingPoint),
  expiresAt: Type.String(),
  updatedAt: Type.Optional(Type.String()),
  articles: Type.Optional(Type.Record(Type.String(), TTalkingPointArticleSummary)),
});
export type TTalkingPointsDocument = Static<typeof TTalkingPointsDocument>;

export const TMediaRankingPrediction = Type.Object({
  media: Type.Array(TFirebaseMediaLibraryItemReady),
  prediction: TPrediction,
  talkingPoints: Type.Optional(Type.String()),
  structuredTalkingPoints: Type.Optional(Type.Array(TStructuredTalkingPoint)),
});
export type TMediaRankingPrediction = Static<typeof TMediaRankingPrediction>;

export const TTrivia = Type.Object({
  question: Type.String(),
  answers: Type.Array(Type.String()),
  correctAnswerIndex: Type.Number(),
  citation: Type.Optional(Type.String()),
});
export type TTrivia = Static<typeof TTrivia>;

export const TTriviaPrediction = Type.Object({
  trivia: TTrivia,
  prediction: TPrediction,
  verifierAgreement: Type.Optional(Type.Boolean()),
});
export type TTriviaPrediction = Static<typeof TTriviaPrediction>;

export const TDynamicQuestionPrediction = Type.Object({
  question: Type.String(),
  answers: Type.Array(Type.String()),
  resolutionRule: TDynamicResolutionRule,
  rationale: Type.String(),
});
export type TDynamicQuestionPrediction = Static<typeof TDynamicQuestionPrediction>;
